// extracted by mini-css-extract-plugin
export default {"carMincontainer":"car_carMincontainer__Fh-XL","frame":"car_frame__+qHkq"};